<template>
    <div
        style="position: fixed; bottom: 70px; right: 10px; z-index: 1000;"
        v-if="$store.state.agentContact"
    >
        <div
            class="wave"
            style="position: relative"
        >
            <div
                class="contact"
                @click="showContact = !showContact"
            >
                <img
                    src="/headphones.png"
                    style="width: 40px; height: 40px"
                    alt=""
                />
            </div>
            <div
                class="contacts-container"
                :class="{ show: showContact }"
            >
                <div style="display: flex; flex-direction: column; gap: 10px">
                    <a
                        :href="`https://t.me/${$store.state.agentContact.telegram_username}`"
                        target="_blank"
                    >
                        <img
                            style="width: 3.5rem; height: 3.5rem"
                            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/smt233/generals/smt223_telegram.png"
                            alt=""
                        />
                    </a>
                    <a :href="`viber://contact?number=%2B${$store.state.agentContact.viber_number}`">
                        <img
                            style="width: 3.5rem; height: 3.5rem;"
                            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/smt233/generals/smt223_viber.png"
                            alt=""
                        />
                    </a>
                    <a
                        v-if="$store.state.agentContact.line_account"
                        :href="`https://line.me/R/ti/p/${$store.state.agentContact.line_account.replace('@', '')}`"
                        target="_blank"
                    >
                        <img
                            style="width: 3.5rem; height: 3.5rem;"
                            src="@/assets/images/line.png"
                            alt="LINE"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showContact: false,
        };
    },
}
</script>

<style scoped>
.contacts-container {
    position: absolute;
    bottom: 110%;
    left: 25%;
    opacity: 0;
    pointer-events: none;
    transform: translateY(20px) translateX(-25%);
    transition: all 0.1s ease-in-out;
}

.contacts-container.show {
    opacity: 1;
    pointer-events: all;
    transform: translateX(-25%) translateY(-10px);
}

.contact {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to right, #5A4BFF, #A557FF);
    position: relative;
    animation: wave 2s linear infinite;
}

@keyframes wave {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(1.2);
    }
}
</style>